import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const routers = [
  {
    path: "/",
    meta: {
      title: "高等教育出版社有限公司"
    },
    component: resolve => require(["./views/index.vue"], resolve)
  },
  {
    path: "/course1",
    meta: {
      title: "高等教育出版社有限公司"
    },
    component: resolve => require(["./views/course1.vue"], resolve)
  },
  {
    path: "/course2",
    meta: {
      title: "高等教育出版社有限公司"
    },
    component: resolve => require(["./views/course2.vue"], resolve)
  },
  {
    path: "/course3",
    meta: {
      title: "高等教育出版社有限公司"
    },
    component: resolve => require(["./views/course3.vue"], resolve)
  },
  {
    path: "/course4",
    meta: {
      title: "高等教育出版社有限公司"
    },
    component: resolve => require(["./views/course4.vue"], resolve)
  },
  {
    path: "/menu",
    meta: {
      title: "高等教育出版社有限公司"
    },
    component: resolve => require(["./views/menu.vue"], resolve)
  }
  // ,
  // {
  //   path: '/course',
  //   meta: {
  //     title: '高等教育出版社有限公司'
  //   },
  //   component: resolve => require(['./views/course.vue'], resolve)
  // },
  // {
  //   path: '/test',
  //   meta: {
  //     title: '高等教育出版社有限公司'
  //   },
  //   component: resolve => require(['./views/test.vue'], resolve)
  // }
];

const RouterConfig = {
  mode: "hash",
  routes: routers
};

export default new Router(RouterConfig);
